module.exports = __webpack_public_path__ + "static/img/intro-cont02.bf0f408.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_b2c/intro-cont02.jpg
// module id = 99Wr
// module chunks = 0